export default "__VITE_ASSET__BmVFu_zF__"